import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { CreateWidgetModel } from '../models';

export function useCreateWidget() {
  return useMutation({
    mutationFn: async (data: CreateWidgetModel) => {
      const res = await $api.post('/v1/dashboard/widget', data);

      return res.data;
    },
    onSuccess: res => {
      showMessage(res.message, true);
    },
    onError: baseErrorHandler
  });
}
